import React, { useEffect } from 'react';  
import { useTranslation } from 'react-i18next';   
import './TeensPage.css'; 
import TeensPriceCard from '../../components/TeensPriceCard/TeensPriceCard'; 
import TeensDetailedDescription from '../../components/TeensDetailedDescription/TeensDetailedDescription';
import TeensHero from '../../components/TeensHero/TeensHero'; 
import TeensMaster from '../../components/TeensMaster'
import VideoContainer from '../../components/VideoContainer/VideoContainer';
import TeensBg from './../../assets/Images/bg/teens.png';
import AssessmentSteps from '../../components/AssessmentSteps';

const TeensPage: React.FC = () => { 
  const { t } = useTranslation(); 
  const handleJoinCourse = () => {
    alert(t("teens_join_alert"));
  };
 

  return (
    <div className="teens-page">
      <TeensHero />
      <TeensDetailedDescription />

      <VideoContainer videoThumbnail={TeensBg} videoUrl="https://vimeo.com/1059520091" />
      
     
      <AssessmentSteps/>
      <TeensMaster/>
      <div className='titleconteinerfuck'>
  <p className='lightteenstex'>{t("teens_innovative_approach")}</p>
  <h3 className='boldteenstext'>{t("teens_best_start")}</h3>
</div>
      <TeensPriceCard
        title={t("teens_join_testing")}
        description={t("teens_join_description")}
        price={2800}
        buttonText={t("teens_book_testing")}
        subtext=""
        onButtonClick={handleJoinCourse}
      />
       
    </div>
  );
};

export default TeensPage;
